export const DRAFT_ORDER_FEATURE = 'draftOrder';
export const DRAFT_ORDER_CORE_FEATURE = 'draftOrderCore';
